.layoutArea {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 100%;
	gap: 0;
}

.snippetList {
	overflow-y: auto;
	flex: 1 0 0;
	margin: 1.2rem 0;
}

.contentArea {
	flex: 1 0 0;
	margin: 1.2rem 1.2rem 1.2rem 0;
}

@media (max-width: 599px) {
	.snippetList,
	.contentArea {
		width: 100%;
		flex: 1;
		margin: 1.2rem 0 0 0;
	}

	.inactivePanel {
		display: none;
	}

	.activePanel {
		display: block;
	}
}

@media (min-width: 600px) and (max-width: 1023px) {
	.snippetList {
		overflow-y: auto;
		flex: 2 0 0;
	}

	.contentArea {
		flex: 4 0 0;
	}
}

@media (min-width: 1024px) {
	.snippetList {
		overflow-y: auto;
		flex: 2 0 0;
	}

	.contentArea {
		flex: 6 0 0;
	}
}
